/* Grondyke · Collection filters. Client-side filter, sort, counts and deep links for
   sections/grondyke-main-collection.liquid. Products carry data attributes rendered from the
   grondyke metafields (profile, scent_family, format, box_contents) and product.type; nothing
   here knows a price beyond the cents the section wrote out. */
(function () {
  'use strict';

  function tokens(str) {
    return (str || '').split(/\s+/).filter(Boolean);
  }
  function intersects(a, b) {
    for (var i = 0; i < a.length; i++) if (b.indexOf(a[i]) >= 0) return true;
    return false;
  }
  /* Axis values match a product token exactly or as a hyphen prefix, so a chip value of
     "bundle" also catches a product.type of "Bundle - Alpha Stack" (bundle-alpha-stack). */
  function matchesValues(chipVals, itemTokens) {
    for (var i = 0; i < chipVals.length; i++) {
      for (var j = 0; j < itemTokens.length; j++) {
        if (itemTokens[j] === chipVals[i] || itemTokens[j].indexOf(chipVals[i] + '-') === 0) return true;
      }
    }
    return false;
  }
  function plural(n, one, many) {
    return n + ' ' + (n === 1 ? one : many);
  }

  function init(root) {
    if (root.__gkInit) return;
    root.__gkInit = true;

    var axisAttr = root.getAttribute('data-axis') || '';
    var axisParam = root.getAttribute('data-axis-param') || '';
    var countMode = root.getAttribute('data-count-mode') || 'scents';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-gk-item]'));
    /* The in-grid promo tile is not a product, so it is deliberately outside `items`: it must
       never be filtered, counted or sorted. render() re-appends every product in sort order,
       which would leave the tile stranded at the top of the grid, so it is put back by hand
       once the products are in place. */
    var tile = root.querySelector('[data-gk-tile]');
    var grid = root.querySelector('[data-gk-grid]');
    var tileAfter = grid ? (parseInt(grid.getAttribute('data-gk-tile-after'), 10) || 0) : 0;
    var profileCards = Array.prototype.slice.call(root.querySelectorAll('[data-gk-profile]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-gk-chip]'));
    var sorts = Array.prototype.slice.call(root.querySelectorAll('[data-gk-sort]'));
    var results = root.querySelector('[data-gk-results]');
    var activeRow = root.querySelector('[data-gk-active]');
    var activeList = root.querySelector('[data-gk-active-list]');
    var clears = Array.prototype.slice.call(root.querySelectorAll('[data-gk-clear]'));
    var empty = root.querySelector('[data-gk-empty]');

    var state = { profiles: [], values: [], sort: 'popular' };

    /* Counts on the profile cards derive from the rendered products. */
    function renderCounts() {
      profileCards.forEach(function (card) {
        var key = card.getAttribute('data-value');
        var slot = card.querySelector('[data-gk-count]');
        if (!slot) return;
        var seen = {};
        var n = 0;
        items.forEach(function (it) {
          var profs = tokens(it.getAttribute('data-profile'));
          if (profs.indexOf(key) < 0) return;
          /* A multi-blend product's scent note is a description of the box, not a scent:
             "the first six scents one bar each", "cedarwood continental musk ocean breeze".
             Counted as values they each read as one more scent, which is why Bond showed 11
             when it has three. They are skipped so the line counts scents you can actually
             pick. Only for the scents mode: a product count still wants every product. */
          if (countMode === 'scents' && profs.indexOf('multi') >= 0) return;
          /* Same for a single-blend box: the Durden Cologne Superpack carries both cedarwood and
             cedarwood lime, so its note is "cedarwood cedarwood lime". Its parts are counted from
             the products themselves. */
          if (countMode === 'scents' && tokens(it.getAttribute('data-type')).indexOf('bundle') >= 0) return;
          var v;
          if (countMode === 'scents') v = it.getAttribute('data-scent') || '';
          else if (countMode === 'formats') v = it.getAttribute('data-format') || '';
          else v = it.getAttribute('data-index');
          if (!v || seen[v]) return;
          seen[v] = true;
          n++;
        });
        if (n === 0) { slot.textContent = ''; return; }
        if (countMode === 'scents') slot.textContent = plural(n, 'scent', 'scents');
        else if (countMode === 'formats') slot.textContent = plural(n, 'format', 'formats');
        else slot.textContent = plural(n, 'product', 'products');
      });
    }

    function matches(it) {
      if (state.profiles.length) {
        if (!intersects(state.profiles, tokens(it.getAttribute('data-profile')))) return false;
      }
      if (state.values.length && axisAttr) {
        if (!matchesValues(state.values, tokens(it.getAttribute('data-' + axisAttr)))) return false;
      }
      return true;
    }

    function sorted(list) {
      var key = state.sort;
      var copy = list.slice();
      copy.sort(function (a, b) {
        var ai = parseInt(a.getAttribute('data-index'), 10);
        var bi = parseInt(b.getAttribute('data-index'), 10);
        if (key === 'low') {
          var ap = parseInt(a.getAttribute('data-price'), 10), bp = parseInt(b.getAttribute('data-price'), 10);
          return ap - bp || ai - bi;
        }
        if (key === 'new') {
          var ac = parseInt(a.getAttribute('data-created'), 10), bc = parseInt(b.getAttribute('data-created'), 10);
          return bc - ac || ai - bi;
        }
        if (key === 'save') {
          var as = parseInt(a.getAttribute('data-save'), 10), bs = parseInt(b.getAttribute('data-save'), 10);
          return bs - as || ai - bi;
        }
        return ai - bi;
      });
      return copy;
    }

    /* The tile sits after a whole row of products that are actually on screen, so a filter that
       empties the first row moves it up rather than leaving a gap above it. With too few products
       left to fill the rows above, it would be the first thing in the grid, so it is hidden. */
    function placeTile(shown) {
      if (!tile || !grid) return;
      if (!tileAfter || shown.length <= tileAfter) { tile.hidden = true; return; }
      tile.hidden = false;
      grid.insertBefore(tile, shown[tileAfter]);
    }

    function render() {
      var visible = 0;
      var shown = [];
      var order = sorted(items);
      order.forEach(function (it) {
        var ok = matches(it);
        it.hidden = !ok;
        if (ok) { visible++; shown.push(it); }
        if (grid) grid.appendChild(it);
      });
      placeTile(shown);

      if (results) results.textContent = plural(visible, 'product', 'products');
      if (empty) empty.hidden = visible !== 0;
      if (grid) grid.hidden = visible === 0;

      profileCards.forEach(function (c) {
        c.setAttribute('aria-pressed', state.profiles.indexOf(c.getAttribute('data-value')) >= 0 ? 'true' : 'false');
      });
      chips.forEach(function (c) {
        var vals = tokens(c.getAttribute('data-value'));
        c.setAttribute('aria-pressed', intersects(vals, state.values) ? 'true' : 'false');
      });
      sorts.forEach(function (b) {
        var on = b.getAttribute('data-gk-sort') === state.sort;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('gk-coll__sort--on', on);
      });

      if (activeRow && activeList) {
        activeList.innerHTML = '';
        var any = false;
        profileCards.forEach(function (c) {
          var v = c.getAttribute('data-value');
          if (state.profiles.indexOf(v) < 0) return;
          any = true;
          var name = c.querySelector('.gk-pcard__name');
          activeList.appendChild(activeChip(name ? name.textContent : v, function () { toggleProfile(v); }));
        });
        chips.forEach(function (c) {
          var vals = tokens(c.getAttribute('data-value'));
          if (!intersects(vals, state.values)) return;
          any = true;
          activeList.appendChild(activeChip(c.getAttribute('data-label') || vals[0], function () { toggleChip(vals); }));
        });
        activeRow.hidden = !any;
      }
      syncUrl();
    }

    function activeChip(label, onClear) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gk-coll__active-chip';
      b.textContent = label + ' ×';
      b.setAttribute('aria-label', 'Remove ' + label);
      b.addEventListener('click', onClear);
      return b;
    }

    function toggleProfile(v) {
      var i = state.profiles.indexOf(v);
      if (i >= 0) state.profiles.splice(i, 1); else state.profiles.push(v);
      render();
    }
    function toggleChip(vals) {
      var on = intersects(vals, state.values);
      state.values = state.values.filter(function (x) { return vals.indexOf(x) < 0; });
      if (!on) state.values = state.values.concat(vals);
      render();
    }
    function clearAll() {
      state.profiles = [];
      state.values = [];
      render();
      var grid0 = root.querySelector('#grid') || root;
      if (grid0 && grid0.scrollIntoView && window.innerWidth < 768) grid0.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /* Deep links: ?profile=bond,maverick&family=aquatic (or format=, box=, type=). */
    function readUrl() {
      var q;
      try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
      var p = q.get('profile');
      if (p) state.profiles = p.split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
      if (axisParam) {
        var v = q.get(axisParam);
        if (v) state.values = v.split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
      }
      var srt = q.get('sort');
      if (srt && sorts.some(function (b) { return b.getAttribute('data-gk-sort') === srt; })) state.sort = srt;
    }
    function syncUrl() {
      if (!window.history || !window.history.replaceState) return;
      var q;
      try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
      if (state.profiles.length) q.set('profile', state.profiles.join(',')); else q.delete('profile');
      if (axisParam) { if (state.values.length) q.set(axisParam, state.values.join(',')); else q.delete(axisParam); }
      if (state.sort !== 'popular') q.set('sort', state.sort); else q.delete('sort');
      var qs = q.toString();
      var url = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
      window.history.replaceState(null, '', url);
    }

    profileCards.forEach(function (c) {
      c.addEventListener('click', function () { toggleProfile(c.getAttribute('data-value')); });
    });
    chips.forEach(function (c) {
      c.addEventListener('click', function () { toggleChip(tokens(c.getAttribute('data-value'))); });
    });
    sorts.forEach(function (b) {
      b.addEventListener('click', function () { state.sort = b.getAttribute('data-gk-sort'); render(); });
    });
    clears.forEach(function (b) { b.addEventListener('click', clearAll); });

    /* Whole-collection filtering.

       Everything above works over the items in the DOM, and the section paginates at 48 (Shopify
       caps `paginate` at 50, so a 79-product collection cannot render in one pass). That left the
       chips and the profile counts seeing only the page you were on: on Shop All the Beard Care
       Bundle is item 79 of 79, so it never appeared under the Bundles chip.

       So the remaining pages are fetched once after first paint and their cards merged into the
       same grid, after which the pager has nothing left to page through and is removed. Items are
       keyed by data-index, which the section now writes as the position in the collection rather
       than within the page, so a merge cannot double up and the default sort stays in collection
       order. If a fetch fails the page simply stays as it was, paginated. */
    function mergeRemainingPages() {
      var totalPages = parseInt(root.getAttribute('data-gk-pages') || '1', 10);
      if (!(totalPages > 1) || !grid || !window.fetch || !window.DOMParser) return;

      var current = 1;
      try {
        var cp = new URLSearchParams(window.location.search).get('page');
        if (cp) current = parseInt(cp, 10) || 1;
      } catch (e) { /* no URLSearchParams: assume page 1 */ }

      var wanted = [];
      for (var p = 1; p <= totalPages; p++) if (p !== current) wanted.push(p);
      if (!wanted.length) return;

      var seen = {};
      items.forEach(function (it) { seen[it.getAttribute('data-index')] = true; });

      var pending = wanted.length;
      var added = false;

      function done() {
        if (--pending > 0) return;
        var pager = root.querySelector('[data-gk-pager]');
        if (pager && added) pager.hidden = true;
        if (added) { renderCounts(); render(); }
      }

      wanted.forEach(function (n) {
        var url = window.location.pathname + '?page=' + n;
        window.fetch(url, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (html) {
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var more = doc.querySelectorAll('[data-gk-item]');
            Array.prototype.forEach.call(more, function (node) {
              var idx = node.getAttribute('data-index');
              if (!idx || seen[idx]) return;
              seen[idx] = true;
              var adopted = document.importNode(node, true);
              items.push(adopted);
              grid.appendChild(adopted);
              added = true;
            });
          })
          .catch(function () { /* leave the page paginated */ })
          .then(done, done);
      });
    }

    renderCounts();
    readUrl();
    render();
    mergeRemainingPages();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-gk-collection]')).forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-gk-collection]') : null;
    if (root) init(root);
  });
})();
